import React from "react";
import { Star, Quote } from "lucide-react";

const reviews = [
  {
    quote:
      "Absolutely incredible attention to detail. My car looked better than when I bought it.",
    name: "Marcus T.",
    car: "BMW M3 Owner",
  },
  {
    quote: "Professional, friendly and worth every dollar.",
    name: "Olivia R.",
    car: "Mercedes GLE",
  },
  {
    quote:
      "The convenience of having them come to my house made the experience effortless.",
    name: "Jason K.",
    car: "Audi RS6",
  },
  {
    quote: "Highly recommend Deluxe Diamond Detailing.",
    name: "Sarah P.",
    car: "Range Rover Sport",
  },
];

export default function Testimonials() {
  return (
    <section
      id="reviews"
      data-testid="testimonials-section"
      className="section bg-[color:var(--bg)]"
    >
      <div className="max-w-[1400px] mx-auto">
        <div className="flex flex-col gap-6 lg:grid lg:grid-cols-12 lg:items-end mb-12">
          <div className="col-span-12 lg:col-span-7">
            <div className="flex items-center gap-3 mb-6 reveal">
              <span className="diamond-divider" />
              <span className="overline">Client Reviews</span>
            </div>
            <h2 className="reveal font-display tracking-tight text-neutral-900 text-4xl md:text-5xl">
              Words from
              <span className="text-neutral-500 font-light italic"> our clients.</span>
            </h2>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-px bg-neutral-200">
          {reviews.map((r, i) => (
            <figure
              key={i}
              data-testid={`testimonial-${i}`}
              className="bg-white p-8 md:p-10 relative reveal hover:bg-neutral-50 transition-colors"
            >
              <Quote
                size={28}
                className="text-[color:var(--accent)]/40 mb-4"
                strokeWidth={1.5}
              />
              <div className="flex items-center gap-1 mb-5">
                {Array.from({ length: 5 }).map((_, idx) => (
                  <Star
                    key={idx}
                    size={14}
                    fill="#f5b301"
                    stroke="#f5b301"
                    className=""
                  />
                ))}
              </div>
              <blockquote className="font-display text-neutral-900 text-xl md:text-2xl leading-snug font-light">
                &ldquo;{r.quote}&rdquo;
              </blockquote>
              <figcaption className="mt-6 flex items-center justify-between text-sm">
                <span className="text-neutral-900 font-semibold">{r.name}</span>
                <span className="text-neutral-400">{r.car}</span>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
